// extracted by mini-css-extract-plugin
export default {"img":"Brands_img__6dbjc"};